import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['onField', 'offField']

  connect() {
    this.switchActivated()
  }

  on() {
    this.toggle(true)
  }

  off() {
    this.toggle(false)
  }

  toggle(active) {
    if (typeof active !== 'boolean') {
      active = !this.element.classList.contains('active')
    }

    this.element.classList.toggle('active', active)

    if (active) {
      this.onFieldTarget.checked = true
    } else {
      this.offFieldTarget.checked = true
    }

    this.switchActivated()
  }

  switchActivated() {
    let active = this.element.classList.contains('active')

    const event = new CustomEvent('switch:activated', {
      detail: {
        name: this.onFieldTarget.name,
        value: active ? this.onFieldTarget.value : this.offFieldTarget.value,
        active: active,
      },
    })
    window.document.dispatchEvent(event)

    this.dispatch('change', {
      detail: {
        active,
        value: active ? this.onFieldTarget.value : this.offFieldTarget.value,
      },
    })
  }
}
